/*
 * this trims confusing data from the url to be able to compare given paths - INSPIRE-2112
 */
export const cleanPathname = (url: string) =>
  url.replaceAll(/^\/de|\/storefront$/g, '').replace(/\/$/, '') || '/';
